import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    showModal: false,
    modalContact: '',
    modalType: ''
}

const Modal = createSlice({
    name: 'Modal',
    initialState,
    reducers: {
        ModalAction: (state, action) => {
            const { showModal, modalContact, modalType } = action.payload
            state.showModal = showModal
            state.modalContact = modalContact
            state.modalType = modalType
        }
    },
    extraReducers: () => {}
})

export const { ModalAction } = Modal.actions
export default Modal.reducer
